export default {
    login_register: 'Prisijungti/Registruotis',
    booking_confirmation_title: 'Užsakymo patvirtinimas',
    booking_confirmation_body: 'Ačiū už jūsų užsakymą. Patvirtinimo detales rasite žemiau.',
    insurance_requirements_modal_disclaimer: `Atlikdamas šį užsakymą patvirtinu, kad: per pastaruosius 5 metus neturėjau teistumų ar kelių eismo pažeidimų. Man nebuvo atsisakyta pasiūlymo, atšaukta polisa ar atsisakyta atnaujinti, taip pat nebuvo reikalaujama mokėti didesnę įmoką ar taikyti specialias sąlygas jokioje draudimo bendrovėje. Nebuvau diskvalifikuotas vairuoti. Neturiu pradėtų baudžiamųjų bylų ar policijos tyrimų. Per pastaruosius 5 metus nebuvau nuteistas už vagystę, sukčiavimą ar nesąžiningumą. Nekenčiu regos ar klausos sutrikimų (kurių negalima ištaisyti akiniais ar klausos aparatu), širdies ligų, diabeto, priepuolių ar kitų fizinių ar psichinių negalių. Per pastaruosius 5 metus neturėjau jokių avarijų. Jei neatitinkate šių reikalavimų, spauskite {0}`,
    insurance_requirements_here: 'čia',
    insurance_requirements: 'Perskaičiau ir supratau {0}',
    ir: 'Draudimo reikalavimai',
    location: 'Vieta',
    pickup_location: 'Atsiėmimo vieta',
    dropoff_location: 'Grąžinimo vieta',
    vehicle: 'Transporto priemonė',
    pickup_and_dropoff: 'Atsiėmimas ir grąžinimas (vietos laiku)',
    view_voucher: 'Peržiūrėti kvitą',
    identity_verification_body: 'Prieš atsiimdami transporto priemonę turėsite patvirtinti savo tapatybę',
    identity_verification_title: 'Tapatybės patvirtinimas',
    search_again: 'Ieškoti dar kartą',
    refrigerated: 'šaldytas',
    aircon_lower: 'kondicionierius',
    aircon: 'Kondicionierius',
    refrigeration: 'Šaldytas',
    not_available: 'Drive & Go šiuo metu prieinama tik asmenims, turintiems asmens tapatybės ir vairuotojo pažymėjimo dokumentus iš šių šalių.',
    check_if_included: 'Patikrinkite, ar jūsų šalis įtraukta.',
    included_in_booking: 'Įtraukta į šį užsakymą',
    cdw_with_excess: 'CDW su franšize',
    theft_protection: 'Apsauga nuo vagystės su franšize',
    risk_reduction: 'Rizikos sumažinimas',
    free_extras: 'Šiam užsakymui priklauso du nemokami priedai <br />.',
    continue: 'Tęsti',
    luggage_large_short_label: 'D',
    luggage_medium_short_label: 'M',
    luggage_small_short_label: 'M',
    luggage_large_long_label: 'didelis',
    luggage_medium_long_label: 'vidutinis',
    luggage_small_long_label: 'mažas',
    fuel_unspecified_label: 'nenustatyta',
    transmission_manual_label: 'Mechaninė',
    transmission_automatic_label: 'Automatinė',
    make_a_booking: 'Atlikti užsakymą',
    pickup_date: 'Atsiėmimo data',
    dropoff_date: 'Grąžinimo data',
    driver_age: 'Vairuotojas nuo 30 iki 65 metų',
    enter_driver_age: 'Įveskite vairuotojo amžių',
    promo_code: 'Nuolaidos kodas',
    search: 'Ieškoti',
    dropoff_date_cannot_be_before_pickup_date: 'Grąžinimo data negali būti ankstesnė nei atsiėmimo data',
    pickup_date_cannot_be_in_the_past: 'Atsiėmimo data negali būti praeityje',
    pickup_time_cannot_be_in_the_past: 'Atsiėmimo laikas negali būti praeityje',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Grąžinimo laikas turi būti vėlesnis nei atsiėmimo, jei tai ta pati diena',
    vehicle_filters: 'Transporto priemonių filtrai',
    reset: 'Atstatyti',
    transmission: 'Pavarų dėžė',
    all: 'Visi',
    manual: 'Mechaninė',
    auto: 'Automatinė',
    passengers: 'Keleiviai',
    vehicle_type: 'Transporto priemonės tipas',
    filter: 'Filtruoti',
    vehicle_search: 'Transporto priemonės paieška',
    edit: 'Redaguoti',
    no_results: 'Pagal jūsų filtrus rezultatų nėra.',
    small_cars: 'Maži automobiliai',
    medium_cars: 'Vidutiniai automobiliai',
    large_cars: 'Dideli automobiliai',
    estate_cars: 'Universalai',
    suvs: 'SUV',
    mpvs: 'Vienatūriai',
    vans: 'Furgonai',
    camper_vans: 'Kemperiai',
    premium: 'Premium',
    unspecified: 'nenustatyta',
    large: 'didelis',
    medium: 'vidutinis',
    small: 'mažas',
    automatic: 'automatinė',
    you_have_been_refunded: 'Jums buvo grąžinti pinigai.',
    please_customer_service: 'Norėdami atlikti užsakymą, susisiekite su mūsų klientų aptarnavimo skyriumi.',
    contact_customer_service: 'Susisiekti su klientų aptarnavimu',
    booking_failed: 'Šį kartą užsakymo apdoroti nepavyko.',
    summary: 'Santrauka',
    reforestation_and_protection: 'Remkite atogrąžų miškų atkūrimą ir apsaugą visoje Kosta Rikoje',
    cost_of_rental: 'Nuomos kaina',
    to_pay_now: 'Mokėti dabar',
    greenheart_donation: 'Green Heart auka',
    total_cost: 'Bendra nuomos kaina',
    tc_agreement: 'Perskaičiau ir supratau {0}.',
    tc: 'Taisyklės ir sąlygos',
    receive_offers: 'Noriu gauti specialius pasiūlymus el. paštu.',
    donate: 'Taip, noriu paaukoti {amount}',
    pay_now: 'Mokėti dabar {amount}',
    driver_details: 'Vairuotojo duomenys',
    complete_driver_details: 'Užpildykite vairuotojo duomenis.',
    are_you_the_driver: 'Ar jūs esate vairuotojas?',
    have_an_account: 'Ar jau turite paskyrą?',
    login: 'Prisijungti',
    or: 'arba',
    first_name: 'Vairuotojo vardas',
    last_name: 'Vairuotojo pavardė',
    email: 'El. pašto adresas',
    phone_number: 'Mobilaus telefono numeris',
    unable_to_save_driver_information: 'Nepavyko išsaugoti vairuotojo informacijos. Bandykite dar kartą.',
    pay_online_now: 'Mokėti dabar',
    day: 'Diena',
    choose_location: 'Pasirinkite vietą',
    location_not_found: 'Atsiprašome, nurodytos vietos neradome.',
    add: 'Pridėti',
    remove: 'Pašalinti',
    free_extra: 'Nemokamas priedas',
    free: 'NEMOKAMAI!',
    fast_track_notice: 'Šiai paslaugai taikomi dokumentų kilmės apribojimai. Galima tik asmenims su dokumentais iš',
    complete_booking: 'Užbaigti užsakymą',
    choose_card: 'Pasirinkite kortelę arba pridėkite naują.',
    add_billing_details: 'Pridėkite atsiskaitymo duomenis.',
    card_number: 'Kortelės numeris',
    card_holder_name: 'Kortelės turėtojo vardas',
    card_exp: 'MM / MM',
    card_cvc: 'CVC',
    save_card: 'Išsaugoti kortelę?',
    amount_charged: 'Nuo jūsų kortelės bus nuskaičiuota',
    payment_confirmation: 'Patvirtinti užsakymą ir mokėti',
    payment_methods: 'galimi mokėjimo būdai',
    use_saved_card: 'x naudoti išsaugotą kortelę',
    use_different_card: '+ naudoti kitą kortelę',
    book_now: 'Užsakyti dabar',
    minimum_age: 'Tik vyresniems nei {age}',
    excess_liability: 'Franšizė',
    security_deposit: 'Užstatas',
    fuel_policy: 'Kuro politika',
    like_for_like: 'Tiek, kiek buvo',
    full_to_full: 'Pilnas-pilnas',
    miles_per_rental: '{mileage} nemokamų mylių už nuomą',
    km_per_rental: '{mileage} nemokamų km už nuomą',
    unlimited_mileage: 'Neribotas nuvažiuotas atstumas',
    unlimited_mileage_km: 'Neriboti kilometrai',
    non_amendable: 'Negalima keisti',
    non_refundable: 'Negrąžinama',
    free_cancellation_until: 'Nemokamas atšaukimas iki',
    cancellation_in_line_with: 'Atšaukimas pagal',
    tcs: 'Taisyklės ir sąlygos',
    free_extras_on_collection: 'Du nemokami priedai atsiimant',
    glass_and_tyres_covered: 'Stiklai ir padangos apdrausti',
    number_of_passengers: 'Keleivių skaičius',
    number_of_bags: 'Krepšių skaičius',
    fuel_type: 'Kuro tipas',
    co2: 'CO2',
    book_type: 'Užsakyti {type}',
    processing: 'Vykdoma',
    actual_price: 'Faktinė kaina',
    tooltip: 'Kaina {currencyCode} valiuta yra preliminari pagal kursą, {currency} valiuta yra galutinė.',
    deposit: 'Užstatas',
    pay_online: 'Mokėti dabar',
    pay_online_without_extras: 'Nuomos kaina',
    extras_on_arrival: 'Priedai atvykus',
    insurance_on_arrival: 'Rizikos sumažinimas - mokėti atvykus',
    insurance_online: 'Rizikos sumažinimas - mokėti dabar',
    extras_online: 'Priedai - mokėti dabar',
    green_heart_donation: 'Green Heart auka',
    why_use_drive_and_go: 'Kodėl rinktis Drive & Go?',
    straight_to_car: 'Tiesiai prie automobilio',
    no_queues: 'Nėra eilių',
    self_checkout: 'Savitarnos atsiėmimas',
    cant_lose_key: 'Negalima pamesti rakto',
    online_id_check: 'Tapatybės patikra internetu',
    phone_as_key: 'Telefonas kaip raktas',
    premiumplus_benefits_includes: 'Taip pat įskaičiuota Premium Plus+ nauda',
    book_drive_go: 'Užsakyti Drive & Go',
    distance_allowance: 'Leidžiamas atstumas',
    duration: 'Trukmė',
    view_more_bookings: 'Rodyti daugiau užsakymų',
    to_pay_on_arrival: 'Mokėti atvykus',
    pay_on_arrival: 'Mokėti atvykus',
    unlimited: 'Neribota',
    return_date: 'Grąžinimo data',
    postcode: 'Pašto kodas',
    country: 'Šalis',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go šiuo metu prieinama tik asmenims, turintiems asmens tapatybės ir vairuotojo pažymėjimo dokumentus iš šių šalių:',
        drive_and_go_today: 'Drive & Go užsakymas šiandien!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Kodėl rinktis Drive & Go?',
        straight_to_car: 'Tiesiai prie automobilio',
        no_queues: 'Nėra eilių',
        self_checkout: 'Savitarnos atsiėmimas',
        cannot_lose_the_key: 'Negalima pamesti rakto',
        online_id_check: 'Tapatybės patikra internetu',
        phone_as_a_key: 'Telefonas kaip raktas',
        premium_plus_benefits_also_included: 'Taip pat įskaičiuota Premium Plus+ nauda',
        book_drive_and_go: 'Užsakyti Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Palapinė ir įranga',
        quick_and_easy: 'Greitai ir lengvai pastatoma',
        travel_freedom: 'Kelionių laisvė',
        affordable_campervan_alternative: 'Prieinama kempingo automobilio alternatyva',
        lightweight_and_compact: 'Lengva ir kompaktiška',
        fully_insured: 'Pilnai apdrausta',
    },
    my_bookings: 'Mano užsakymas',
    no_bookings: 'Nėra užsakymų',
    my_profile: 'Mano profilis',
    no_bookings_to_display: 'Nėra užsakymų rodymui.',
    search_great_car_rental_deals: 'Ieškokite puikių automobilių nuomos pasiūlymų savo kitai kelionei.',
    odometer_at_collection: 'Rida atsiėmimo metu',
    fuel_at_collection: 'Kuras atsiėmimo metu',
    start_check_in: 'Pradėti registraciją',
    start_collection: 'Pradėti atsiėmimą',
    recent_bookings: 'Naujausias užsakymas',
    damage: {
        updated_damage_report_submitted: 'Atnaujinta žalos ataskaita pateikta. Jei reikės, su jumis susisieks mūsų klientų aptarnavimo komanda.',
        add_additional_damage: 'Pridėti papildomą žalą',
        you_may_report_additional_damage_up_to: 'Papildomą žalą galite pranešti per 24 val. po automobilio grąžinimo',
        specify_damage: 'Nurodykite žalą',
        please_choose_the_area_and_type_of_damage: 'Pasirinkite žalos vietą ir tipą',
        type_of_damage: 'Žalos tipas',
        is_this_more_than_5_cm: 'Ar tai daugiau nei 5 cm?',
        please_take_or_select_a_photo: 'Padarykite arba pasirinkite nuotrauką',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Padarykite nuotrauką, kad žala būtų aiškiai matoma',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Jei reikia, galite pridėti dar vieną nuotrauką, pasirinkite piktogramą',
        save_image: 'Išsaugoti nuotrauką',
        save_images: 'Išsaugoti nuotraukas',
        damage_saved_successfully: 'Žala sėkmingai išsaugota',
        add_photo: 'Pridėti nuotrauką',
    },
    checkout: {
        start_collection: 'Pradėti atsiėmimą',
        collect_vehicle: 'Atsiimti automobilį',
        we_will_let_you_know_the_details: 'Pranešime jums vietą ir detales, kad galėtumėte rasti nuomojamą automobilį.',
        inspect: 'Apžiūrėti',
        we_will_ask_for_four_photos_from_each_corner: 'Prašysime keturių nuotraukų iš kiekvieno automobilio kampo ir visų naujų, dar neužfiksuotų pažeidimų.',
        fuel_and_milage: 'Kuras ir rida',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Patvirtinate ridą ir kuro lygį nuomos pradžioje.',
        sign: 'Pasirašyti',
        sign_the_rental_agreement: 'Pasirašyti nuomos sutartį.',
        away_you_go: 'Geros kelionės',
        you_are_free_to_take_to_the_road: 'Galite pradėti kelionę!',
        collect_your_vehicle: 'Atsiimkite savo automobilį',
        get_directions: 'Gauti nuorodas',
        hide_directions: 'Slėpti nuorodas',
        local_time: 'vietos laikas',
        tel: 'Tel',
        getting_to_the_location: 'Kaip nuvykti į vietą',
        get_vehicle_details: 'Gauti automobilio duomenis',
        view_map: 'Peržiūrėti žemėlapį',
        unlock_vehicle_and_continue: 'Atrakinti automobilį ir tęsti',
        unable_to_connect_to_vehicle: 'Nepavyko prisijungti prie automobilio',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Nepavyko prisijungti prie automobilio – patikrinkite, ar esate prie tinkamo automobilio, ir bandykite dar kartą.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nepavyko rasti automobilio užsakymo. Bandykite vėliau.',
        odometer_and_fuel: 'Rida ir kuras',
        odometer: 'Rida',
        please_confirm_the_odometer_and_fuel_readings: 'Jei įmanoma, patvirtinkite ridą ir kuro lygį.',
        the_odometer_field_is_required: 'Ridos laukas yra privalomas',
        and_must_be_greater_than_the_checkout_odometer: 'ir turi būti didesnė nei atsiėmimo metu',
        confirm: 'Patvirtinti',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Padarykite nuotrauką iš kiekvieno automobilio kampo',
        pre_existing_damage: 'Esama žala',
        no_pre_existing_damage: 'Nėra esamos žalos.',
        new_damage: 'Nauja žala',
        add_additional_damage: 'pridėti papildomą žalą',
        no_new_damage_to_report: 'Nėra naujos žalos',
        checkout_complete: 'Atsiėmimas baigtas',
        start_rental: 'Pradėti nuomą',
        congratulations_name_it_is_time_to_take_to_the_road: 'Sveikiname, {customer_name}, laikas pradėti kelionę!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Nepavyko užbaigti automobilio atsiėmimo.',
        please_do_the_following: 'Atlikite šiuos veiksmus',
        remove_all_belonging_and_lock_the_vehicle: 'Išimkite visus daiktus ir užrakinkite automobilį.',
        lock_vehicle: 'Užrakinti automobilį',
        once_you_have_contacted_customer_services: 'Kai susisieksite su klientų aptarnavimu',
        vehicle_location: 'Automobilio vieta',
        collect_your: 'Atsiimkite savo',
        from: 'Iš',
        key_in_glove_box: 'raktas yra daiktadėžėje',

        keyholder: {
            not_detected: 'Raktas nerastas laikiklyje',
            not_detected_please_try_again: 'Įdėkite raktą į laikiklį ir bandykite dar kartą.',

            not_installed: 'Raktų laikiklis neįdiegtas',
            not_installed_please_contact_customer_service: 'Raktų laikiklis neįdiegtas, susisiekite su klientų aptarnavimu.',
        },
        keyring: {
            look_up_failed: 'Nepavyko rasti raktų laikiklio',
            look_up_failed_please_contact_customer_service: 'Nepavyko rasti raktų laikiklio, susisiekite su klientų aptarnavimu.',
        },
        key: {
            invalid: 'Raktas netinkamas',
            invalid_please_contact_customer_service: 'Jūsų raktas netinkamas, susisiekite su klientų aptarnavimu.',

            expired: 'Raktas nebegalioja',
            expired__please_contact_customer_service: 'Jūsų raktas nebegalioja, susisiekite su klientų aptarnavimu.',
        },
    },
    checkin: {
        start_check_in: 'Pradėti registraciją',
        vehicle_location: 'Automobilio vieta',
        tell_us_where_you_have_parked: 'Pasakykite, kur pastatėte automobilį.',
        fuel_and_milage: 'Kuras ir rida',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Patvirtinate ridą ir kuro lygį nuomos pabaigoje.',
        inspect: 'Apžiūrėti',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Prašysime keturių nuotraukų iš kiekvieno automobilio kampo ir visų naujų žalos atvejų nuomos metu.',
        lock: 'Užrakinti',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Patikrinkite, ar nepalikote daiktų, tada užrakinkite automobilį.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Pasakykite, kur pastatėte automobilį',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Užrakinus automobilį, jo nebegalėsite atrakinti.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle:
            '{first_name}, patikrinkite, ar nepalikote daiktų, užrakinkite automobilį ir, jei reikia, grąžinkite fizinį raktą į laikiklį.',
        lock_vehicle: 'Užrakinti automobilį',
        complete_check_in: 'Baigti registraciją',
        inspection: 'Apžiūra',
        complete_vehicle_check_in: 'Baigti automobilio registraciją',
        we_are_unable_to_complete_your_vehicle_check_in: 'Nepavyko užbaigti automobilio registracijos.',
        please_contact_customer_services: 'Susisiekite su klientų aptarnavimu',
        once_you_have_contacted_customer_services: 'Kai susisieksite su klientų aptarnavimu',
        please_amend_odometer_to_be_greater_than: 'Pakeiskite ridą į didesnę nei {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Nuomos sutartis',
        agreement_between: 'Sutartis tarp',
        and: 'ir',
        sign_rental_agreement: 'Pasirašyti nuomos sutartį',
        i_have_read_and_understood_the_terms_and_conditions: 'Perskaičiau ir supratau taisykles ir sąlygas bei sutinku su automobilio būkle',
    },
    additional_options: 'Papildomos parinktys',
    booking_details: 'Užsakymo detalės',
    price_for_x_days: 'Kaina už {qty_of_days} dieną | Kaina už {qty_of_days} dienas',
    cancelled: 'Atšaukta',
    upcoming: 'Artėjantis',
    active: 'Aktyvus',
    full_insurance_no_deposit: 'Pilnas draudimas ir nereikalingas užstatas',
    excess: '{amount} franšizė',
    deposit: '{amount} užstatas',
    included_daily_distance: '{distance} {unit} per dieną',
    miles: 'mylios',
    kilometers: 'kilometrai',
    collection_details_title: 'Atsiėmimo detalės',
    collection_details_not_found: 'Šiai vietai nėra apibrėžtų atsiėmimo detalių',
    free_cancellation: 'Nemokamas atšaukimas',
    no_deposit: 'Be užstato',
    benefit_from: 'Pasinaudokite',
    for_only_per_day: 'Tik už {price} per dieną',
    upgrade_mee: 'UpgradeMee',
};
